<template>
  <div>
    <tag-label-group v-if="qualificationTagItems.length" :items="qualificationTagItems" class="mt-16" />
    <tag-label-group v-if="languagesTagItems.length" :items="languagesTagItems" class="mt-16" />
  </div>
</template>

<script lang="ts">
import TagLabelGroup from '@/components/tag_label_group/TagLabelGroup.vue';
import {
  childCareQualificationMap,
  companionCareQualificationMap,
  languageMap,
} from '@/apps/provider/profile/__types__/SkillsTypes';
import type { ChildCareQualification, CompanionCareQualification, Language } from '@/apps/provider/profile/__types__/SkillsTypes';

export default {
  name: 'ProfileSkills',
  components: { TagLabelGroup },
  props: {
    careType: {
      type: String,
      required: true,
    },
    qualifications: {
      type: Array as () => Array<ChildCareQualification | CompanionCareQualification>,
      default: () => [],
    },
    childCareQualifications: {
      type: Array as () => ChildCareQualification[],
      default: () => [],
    },
    languagesSpoken: {
      type: Array as () => Language[],
      default: () => [],
    },
  },
  computed: {
    qualificationTagItems(): { text: string }[] {
      if (['babysitter', 'nanny'].includes(this.careType)) {
        const qualifications = Array.isArray(this.qualifications)
          ? this.qualifications.filter((q): q is ChildCareQualification => q in childCareQualificationMap)
          : [];
        const childCareQualifications = Array.isArray(this.childCareQualifications)
          ? this.childCareQualifications.filter((q): q is ChildCareQualification => q in childCareQualificationMap)
          : [];
        const unique = Array.from(new Set([...qualifications, ...childCareQualifications]));
        return unique.map((q) => childCareQualificationMap[q]).filter(Boolean);
      }
      if (this.careType === 'companionCare' && Array.isArray(this.qualifications)) {
        const companionQualifications = (this.qualifications as CompanionCareQualification[]).filter(
          (q): q is CompanionCareQualification => q in companionCareQualificationMap
        );
        const unique = Array.from(new Set(companionQualifications));
        return unique.map((q) => companionCareQualificationMap[q]).filter(Boolean);
      }
      return [];
    },
    languagesTagItems(): { text: string }[] {
      if (Array.isArray(this.languagesSpoken) && this.languagesSpoken.length) {
        const formatted = (this.languagesSpoken as Language[])
          .filter(Boolean)
          .map((lang) => languageMap[lang]?.text || lang)
          .join(', ');
        return [{ text: `Languages: ${formatted}` }];
      }
      return [];
    },
  },
};
</script>
